import { render, staticRenderFns } from "./SaldoServicos.vue?vue&type=template&id=eead1900"
import script from "./SaldoServicos.vue?vue&type=script&lang=js"
export * from "./SaldoServicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports